<template>
    <div style="height: 100%; width: 100%;">
        <div class="container mt-3" style="z-index: 1000;">
            <div class="row" style="overflow-x: hidden; min-height: 500px;">
                <div class="column" style="border-right: 2px solid #264a74; flex-grow: 0;">
                    <div class="mb-3" style="height: 100px; width: 260px;">
                        <b-datepicker v-model="selectedDate.dateRange" placeholder="Select a range of dates..."
                            icon="fa-solid fa-calendar-day"
                            :icon-right="selectedDate.dateRange && selectedDate.dateRange.length > 0 ? 'fa-solid fa-circle-xmark' : ''"
                            icon-right-clickable range :events="datesStudied" @icon-right-click="clearDates" trap-focus
                            style="z-index: 1010;" />
                        <b-select placeholder="Time resolution" v-model="scale" class="mt-3" style="z-index: 1001;">
                            <option value="15">15 minutes</option>
                            <option value="30">30 minutes</option>
                            <option value="60">1 hour</option>
                            <option value="180">3 hours</option>
                        </b-select>
                    </div>
                    <div v-for="enrollment in selectedDate.enrollments" class="row mb-3"
                        style="height: 75px; border-top: 2px solid #264a74; align-items: center;">
                        <i class="fa-solid fa-circle mr-2" :style="[enrollment.style]"></i>
                        <div style="width: 260px;">
                            {{ enrollment.title.length > 60 ? enrollment.title.substring(0, 60) + '...' : enrollment.title
                            }}
                        </div>
                    </div>
                </div>

                <div class="column" style="overflow-x: scroll;">
                    <div class="container" style="margin: 0;">
                        <div class="mb-3" style="height: 100px; flex-grow: 1; align-items: center;">
                            <div class="row mb-3 mt-3">
                                <div v-for="interval in intervals">
                                    <div v-if="interval.time == '12:00 am'"
                                        style="height: 30px; text-align: center; padding: 5px; font-weight: bold;">
                                        {{ moment(interval.date).format("MMM D, YYYY") }}
                                    </div>
                                    <div v-else style="height: 30px;">
                                    </div>
                                    <div class="label">
                                        {{ interval.time }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="enrollment in selectedDate.enrollments" class="row mb-3"
                            style="height: 75px; align-items: center;">
                            <div v-for="event in enrollment.events">
                                <div v-if="event.name != 'Empty'" class="event" :style="[event.style]">
                                    <b-tooltip
                                        :label="moment(event.start_date).format('hh:mm a') + ' - ' + moment(event.end_date).format('hh:mm a')"
                                        style="width: 100%;">
                                        {{ event.length }} min
                                    </b-tooltip>
                                </div>
                                <div v-else class="space" :style="[event.style]"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { client as http } from "@/http_client";

import CardToolbar from "@/TIER/components/CardToolbar";

export default {
    components: { CardToolbar },
    props: ['userId'],
    data() {
        return {
            rawData: [],
            parsedData: [],
            cleanData: [],
            intervals: [],
            scale: 60,
            moment: moment,
            selectedDate: {
                dateRange: [],
                enrollments: [
                    {
                        enrollment_id: 0,
                        title: 'No Study Sessions',
                        color: '#000000',
                        style: {
                            color: '#000000',
                        },
                        events: [
                        ],
                    },
                ],
            },
            datesStudied: [],
        };
    },
    methods: {
        clearDates() {
            this.selectedDate.dates = [];
        },
        clearDate() {
            this.selectedDate.date = null;
        },
        getEvents(cb) {
            http.get(`users/${this.userId}/study_log`).then((response) => {
                this.rawData = response.data;
                if (cb)
                    cb();
            });
        },
        parseRawData() {
            this.parsedData = [];
            this.rawData.forEach(event => {
                if (moment(event.start_date).format('YYYY-MM-DD') != moment(event.end_date).format('YYYY-MM-DD')) {
                    let start_date = moment(event.start_date).format('YYYY-MM-DD HH:mm:ss');
                    let end_date = moment(event.end_date).format('YYYY-MM-DD HH:mm:ss');

                    let firstEvent = structuredClone(event);
                    let secondEvent = structuredClone(event);
                    firstEvent.end_date = moment(start_date).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                    firstEvent.length = moment(firstEvent.end_date).endOf('day').diff(moment(firstEvent.start_date), 'minutes');
                    firstEvent.style = {
                        width: (firstEvent.length / this.scale) * 110 - 10 + 'px',
                        backgroundColor: firstEvent.color,
                    };

                    secondEvent.start_date = moment(end_date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    secondEvent.length = moment(secondEvent.end_date).diff(moment(secondEvent.start_date), 'minutes');
                    secondEvent.style = {
                        width: (secondEvent.length / this.scale) * 110 - 10 + 'px',
                        backgroundColor: secondEvent.color,
                    };
                    this.parseEvent(firstEvent);
                    this.parseEvent(secondEvent);
                } else {
                    event.style = {
                        width: (event.length / this.scale) * 110 - 10 + 'px',
                        backgroundColor: event.color,
                    }
                    this.parseEvent(event);
                }
            });
        },
        parseEvent(event) {
            if (!this.parsedData.some(date => date.date == moment(event.start_date).format('YYYY-MM-DD'))) {
                this.parsedData.push({
                    date: moment(event.start_date).format('YYYY-MM-DD'),
                    enrollments: [
                        {
                            enrollment_id: event.enrollment_id,
                            title: event.enrollment_title,
                            color: event.color,
                            style: {
                                color: event.color,
                            },
                            events: [
                                event,
                            ],
                        },
                    ],
                });
            } else {
                this.parsedData.forEach(date => {
                    if (date.date == moment(event.start_date).format('YYYY-MM-DD'))
                        if (!date.enrollments.some(enrollment => enrollment.enrollment_id == event.enrollment_id))
                            date.enrollments.push({
                                enrollment_id: event.enrollment_id,
                                title: event.enrollment_title,
                                color: event.color,
                                style: {
                                    color: event.color,
                                },
                                events: [
                                    event,
                                ],
                            });
                        else
                            date.enrollments.forEach(enrollment => {
                                if (enrollment.enrollment_id == event.enrollment_id)
                                    enrollment.events.push(event);
                            });
                });
            }
        },
        addEmptySpace() {
            let temp, end;
            this.cleanData = [];

            this.parsedData.forEach(day => {
                this.cleanData.push({
                    date: day.date,
                    enrollments: [],
                });
                day.enrollments.forEach(enrollment => {
                    this.cleanData[this.cleanData.length - 1].enrollments.push({
                        enrollment_id: enrollment.enrollment_id,
                        title: enrollment.title,
                        color: enrollment.color,
                        style: {
                            color: enrollment.color,
                        },
                        events: [],
                    });
                    temp = moment(moment(enrollment.events[0].start_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
                    end = moment(moment(enrollment.events[enrollment.events.length - 1].end_date).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
                    for (let i = 0; i < enrollment.events.length; i++) {
                        if (temp.isBefore(moment(enrollment.events[i].start_date))) {
                            this.cleanData[this.cleanData.length - 1].enrollments[this.cleanData[this.cleanData.length - 1].enrollments.length - 1].events.push({
                                name: "Empty",
                                empty: true,
                                start_date: temp.format('YYYY-MM-DD HH:mm:ss'),
                                end_date: moment(enrollment.events[i].start_date).format('YYYY-MM-DD HH:mm:ss'),
                                length: moment(enrollment.events[i].start_date).diff(temp, 'minutes'),
                                style: {
                                    width: (moment(enrollment.events[i].start_date).diff(temp, 'minutes') / this.scale) * 110 - 10 + 'px',
                                },
                            });
                            this.cleanData[this.cleanData.length - 1].enrollments[this.cleanData[this.cleanData.length - 1].enrollments.length - 1].events.push(enrollment.events[i]);
                        } else {
                            this.cleanData[this.cleanData.length - 1].enrollments[this.cleanData[this.cleanData.length - 1].enrollments.length - 1].events.push(enrollment.events[i]);
                        }
                        temp = moment(enrollment.events[i].end_date);
                    }
                    if (temp.isBefore(end))
                        this.cleanData[this.cleanData.length - 1].enrollments[this.cleanData[this.cleanData.length - 1].enrollments.length - 1].events.push({
                            name: "Empty",
                            empty: true,
                            start_date: temp.format('YYYY-MM-DD HH:mm:ss'),
                            end_date: end.format('YYYY-MM-DD HH:mm:ss'),
                            length: end.diff(temp, 'minutes'),
                            style: {
                                width: (end.diff(temp, 'minutes') / this.scale) * 110 - 10 + 'px',
                            },
                        });
                });
            });
        },
        createIntervals() {
            this.intervals = [];
            let start = moment(this.selectedDate.dateRange[0]).startOf('day');
            let end = moment(this.selectedDate.dateRange[1]).endOf('day');
            while (start.isBefore(end)) {
                this.intervals.push({
                    start: start.format('HH:mm:ss'),
                    date: start.format('YYYY-MM-DD'),
                    time: start.format('hh:mm a'),
                    end: start.add(this.scale, 'minutes').format('HH:mm:ss'),
                });
            }
        },
        populateDatesStudied() {
            this.datesStudied = [];
            this.cleanData.forEach(date => {
                if (date.enrollments.length > 0)
                    this.datesStudied.push(new Date(date.date));
            });
        },
        dateRangeWatcher(val) {
            console.log('selectedDate.dateRange')
            this.selectedDate.enrollments = [];
            if (!val || val.length == 0) {
                this.selectedDate.enrollments.push({
                    enrollment_id: 0,
                    title: "No Study Sessions",
                    color: "#000000",
                    style: {
                        color: "#000000",
                    },
                    events: [
                    ],
                });
                return;
            }
            let temp = moment(val[0]);
            let end = moment(val[1]).endOf('day');
            while (temp.isSameOrBefore(end)) {
                if (this.cleanData.some(date => date.date == temp.format('YYYY-MM-DD')))
                    this.cleanData.find(date => date.date == temp.format('YYYY-MM-DD')).enrollments.forEach(enrollment => {
                        if (!this.selectedDate.enrollments.some(e => e.enrollment_id == enrollment.enrollment_id))
                            this.selectedDate.enrollments.push({
                                enrollment_id: enrollment.enrollment_id,
                                title: enrollment.title,
                                color: enrollment.color,
                                style: {
                                    color: enrollment.color,
                                },
                                events: [],
                            });
                    });
                temp.add(1, 'days');
            }
            if (this.selectedDate.enrollments.length == 0) {
                this.selectedDate.enrollments.push({
                    enrollment_id: 0,
                    title: "No Study Sessions",
                    color: "#000000",
                    style: {
                        color: "#000000",
                    },
                    events: [
                    ],
                });
                return;
            }
            temp = moment(val[0]);
            while (temp.isSameOrBefore(end)) {
                if (!this.cleanData.some(date => date.date == temp.format('YYYY-MM-DD'))) {
                    // add empty space for all enrollments for this date
                    this.selectedDate.enrollments.forEach(enrollment => {
                        enrollment.events.push({
                            name: "Empty",
                            empty: true,
                            start_date: temp.format('YYYY-MM-DD HH:mm:ss'),
                            end_date: temp.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                            // get time difference between temp and start_date in minutes
                            length: 1440,
                            style: {
                                width: (1440 / this.scale) * 110 - 10 + 'px',
                            },
                        })
                    })
                    temp.add(1, 'days');
                    continue;
                }
                this.cleanData.find(date => date.date == temp.format('YYYY-MM-DD')).enrollments.forEach(enrollment => {
                    this.selectedDate.enrollments.find(e => e.enrollment_id == enrollment.enrollment_id).events.push(...enrollment.events);
                });
                this.selectedDate.enrollments.forEach(enrollment => {
                    if (!enrollment.events || enrollment.events.length == 0 || enrollment.events[enrollment.events.length - 1].end_date != temp.endOf('day').format('YYYY-MM-DD HH:mm:ss'))
                        enrollment.events.push({
                            name: "Empty",
                            empty: true,
                            start_date: temp.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                            end_date: temp.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                            length: 1440,
                            style: {
                                width: (1440 / this.scale) * 110 - 10 + 'px',
                            },
                        });
                });
                temp.add(1, 'days');
            }
            if (this.selectedDate.enrollments.length == 0)
                this.selectedDate.enrollments.push({
                    enrollment_id: 0,
                    title: "No Study Sessions",
                    color: "#000000",
                    style: {
                        color: "#000000",
                    },
                    events: [
                    ],
                });
            console.log(this.selectedDate.enrollments)
            this.createIntervals();
        },
    },
    watch: {
        'selectedDate.date': function (val) {
            val = moment(val);
            if (this.cleanData.some(date => date.date == val.format('YYYY-MM-DD')))
                this.selectedDate.data = this.cleanData.find(date => date.date == val.format('YYYY-MM-DD'));
            else
                this.selectedDate.data = {
                    date: val.format('YYYY-MM-DD'),
                    enrollments: [
                        {
                            enrollment_id: 0,
                            title: "No Study Sessions",
                            events: [
                            ],
                        },
                    ],
                };
        },
        'selectedDate.dateRange': function (val) {
            this.dateRangeWatcher(val);
        },
        scale: function (val) {
            console.log('scale', val)
            this.parseRawData();
            this.addEmptySpace();
            this.createIntervals();

            this.dateRangeWatcher(this.selectedDate.dateRange);
        },
    },
    mounted: function () {
        this.getEvents(() => {
            this.parseRawData();
            this.addEmptySpace();
            this.createIntervals();
            this.populateDatesStudied();
            this.selectedDate.date = new Date();
        });
    },
}
</script>

<style scoped lang="css">
.container {
    display: flex;
    flex-direction: column;
    overflow-x: scroll;
}

.row {
    display: flex;
    flex-direction: row;
}

.event {
    height: 30px;
    background-color: #92beeb;
    /* color: white; */
    font-weight: bold;
    margin: 5px;
    flex-shrink: 0;
    padding: 5px;
    border-radius: 5px;
}

.space {
    height: 30px;
    margin: 5px;
    flex-shrink: 0;
    background-color: #e9e9e9;
    border-radius: 5px;
}

.label {
    height: 30px;
    background-color: #264973;
    color: white;
    margin: 5px;
    text-align: center;
    width: 100px;
    flex-shrink: 0;
    padding: 5px;
    border-radius: 5px;
}
</style>